import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Label } from "components/bootstrap";
const StyledLabel = styled(Label)`
  margin-left: 5px;
  vertical-align: inherit;
`;
const DefaultLabel = () => {
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement(StyledLabel, { bsStyle: "primary", bsSize: "xsmall" }, t("badges.default"));
};
export default DefaultLabel;
